import { makeStyles, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import MySelect from './MySelect';

const useStyles = makeStyles({
  label: {
    '& .MuiInputBase-input': {
      fontWeight: 'bold',
    },
  },
});

const MyForm = (props) => {
  const classes = useStyles();

  return (
    <div className="form-flex">
      {
        props.form.map((f) => {
          switch (f.type) {
            case 'select':
              return (
                <MySelect
                  key={f.id}
                  handleChange={(e) => props.onChange(e.value, f.id)}
                  value={props.data[f.id]}
                  label={f.label}
                  datas={f.options}
                  style={{ width: '100%', margin: 'auto', minWidth: '250px' }}
                  classStyle={true}
                  disabled={!props.wsStatus}
                />
              );
            case 'autocomplete':
              return (
                <Autocomplete
                  key={f.id}
                  options={f.options}
                  value={f.value ? f.value : null}
                  onChange={(e, v) => props.onChange(v, f.id)}
                  onInputChange={(e, v) => props.onChange(e.target.value, f.inputValue)}
                  getOptionLabel={(option) => option.libelle}
                  getOptionSelected={(option, value) => option.code === value.code}
                  style={{ width: '100%', margin: 'auto', minWidth: '250px' }}
                  renderInput={(params) => <TextField {...params} label={f.label} InputLabelProps={{ shrink: true }} />}
                  disabled={!props.wsStatus}
                />
              );
            default:
              return (
                <TextField
                  key={f.id}
                  className={classes.label}
                  label={f.label}
                  type="text"
                  value={props.data[f.id] || ''}
                  onChange={(e) => props.onChange(e.target.value, f.id)}
                  style={{ width: '100%', minWidth: '250px', margin: 'auto' }}
                  autoComplete={'off'}
                  required={f.required}
                  disabled={f.disabled}
                  error={f.pattern && props.data[f.id] ? !f.pattern.test(String(props.data[f.id]).toLowerCase()) : null}
                  helperText={f.pattern && props.data[f.id] && !f.pattern.test(String(props.data[f.id]).toLowerCase()) ? f.errorLabel : ''}
                  placeholder={f.placeholder}
                  multiline={f.multiline}
                  maxrows={f.maxRows ? f.maxRows : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: f.readOnly,
                  }}
                />
              );
          }
        })
      }

    </div>
  );

};

export default MyForm;